module.exports = __webpack_public_path__ + "0090cf20982dda2dfaf35babd9a01ef8.pdf";